import React, { lazy } from 'react';

// Lazy-loaded page components (code-split per page)
const CashierActivateDeactivate = lazy(() => import('./pages/cashManagement/CashierActivateDeactivate'));
const CashierManagement = lazy(() => import('./pages/cashManagement/CashierManagement'));
const CashierStatus = lazy(() => import('./pages/cashManagement/CashierStatus'));
const SubsidiaryTransactionsReport = lazy(() => import('./pages/reports/SubsidiaryTransactionsReport'));

/**
 * Manager feature permission-to-component map.
 * Keys match the `name` field from backend permissions.
 */
export const managerPages = (displayName: string): Record<string, React.ReactNode> => ({
  cashierActivate: <CashierActivateDeactivate title={displayName} />,
  cashierStatus: <CashierStatus />,
  cashierManagement: <CashierManagement />,
  trnCashier: <SubsidiaryTransactionsReport title={displayName} />,
});
